import OpacityAnimation from '@components/utils/helpers/opacityAnimation';
import MainContainer from '../atoms/container/mainContainer';
import SearchContainer from '../atoms/container/searchContainer';
import SearchInput from '../sections/search/searchInput';
import SearchKeyboard from '../sections/search/searchKeyboard';
import SearchResults from '../sections/search/searchResults';
import useBackKeyboard from '@shared/components/utils/hooks/useBackKeyboard';
import useSearch from '../../../shared/components/utils/hooks/useSearch';

function TSearch() {
  // Search hook

  const {
    animation,
    asset,
    error,
    input,
    message,
    opacity,
    queries,
    rails,
    searching,
    selection,
    totalResults,
    clearAction,
    searchAction,
    setAsset,
    onChangeElement,
    onChangeInput,
    onDeleteInput,
    onMouseEnter,
    outOfBoundsAction,
  } = useSearch();

  // Components data

  const actions = {
    clearAction,
    searchAction,
    onChangeElement,
    onChangeInput,
    onDeleteInput,
    outOfBoundsAction,
  };

  const context = {
    asset,
    complete: rails.length > 0,
    hidePreviousItem: true,
    rails,
    onChangeElement,
    outOfBoundsAction,
    setAsset,
    setFilter: () => null,
  };

  // Keyboard hooks
  useBackKeyboard();
  return (
    <MainContainer>
      <OpacityAnimation>
        <SearchContainer
          animation={animation}
          force={true}
          onMouseEnter={onMouseEnter}
          style={{ opacity }}
        >
          <SearchKeyboard actions={actions} queries={queries} />
          <SearchResults
            context={context}
            message={message}
            input={input}
            searching={searching}
          />
          <SearchInput
            input={input}
            error={error}
            results={totalResults}
            searching={searching}
            selection={selection}
          />
        </SearchContainer>
      </OpacityAnimation>
    </MainContainer>
  );
}

export default TSearch;
